<template>
  <div class="job_card">
    <div class="job_header">
      <span>{{ jobInfo.jobName }}</span>
      <span v-if="jobInfo.provideSalaryString">{{
        jobInfo.provideSalaryString
      }}</span>
    </div>
    <div class="job_tag_wrap" v-if="jobInfo.jobTags?.length > 0">
      <div class="tag_div">
        <span
          v-for="(tag, tkey) in jobInfo.jobTags"
          :key="tkey"
          :style="{ display: !tag ? 'none' : 'block' }"
          >{{ tag }}</span
        >
      </div>
    </div>
    <div class="company_info">
      <span v-if="jobInfo.companyName">{{ jobInfo.companyName }}</span>
      <span v-if="jobInfo.companyTypeString">{{
        jobInfo.companyTypeString
      }}</span>
      <span v-if="jobInfo.companySizeString">{{
        jobInfo.companySizeString
      }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "JobCard",
  props: {
    jobInfo: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
<style scoped lang="less">
.job_card {
  background: rgba(255, 255, 255, 0.75);
  border-radius: 8px;
  border: 2px solid #ffffff;
  padding: 24px 16px;
  margin: 8px;
  margin-bottom: 0;
  .job_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 600;
    font-size: 18px;
    color: #ff6c0e;
    line-height: 15px;
    & > span {
      &:first-child {
        color: #222222;
        line-height: 19px;
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &:nth-child(2) {
        margin-left: 26px;
      }
    }
  }
  .job_tag_wrap {
    margin-top: 8px;
    display: flex;
    flex-flow: row;
    overflow: hidden;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    .tag_div {
      display: flex;
      flex-flow: row;
      align-items: center;
      max-width: 260px;
      flex-grow: 0;
      overflow: hidden;
      height: 20px;
      flex-wrap: wrap;
      & > span {
        font-size: 12px;
        background: #f4f8fb;
        border-radius: 3px;
        margin-right: 5px;
        margin-bottom: 2px;
        padding: 0 6px;
        line-height: 10px;
        color: #4c4f54;
        flex-shrink: 0;
        padding: 5px 5px;
        min-height: 20px;
      }
    }
  }
  .company_info {
    font-weight: 400;
    font-size: 14px;
    color: #4c4f54;
    line-height: 14px;
    margin-top: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    & > span {
      margin: 0 4px;
      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
